export enum AuthErrorCode {
  AuthTokenMissingOrInvalid = 'auth_token_missing_or_invalid',
  AuthTokenInvalidSignature = 'auth_token_invalid_signature',
  AuthTokenExpired = 'auth_token_expired',
  AuthTokenInvalid = 'auth_token_invalid',

  RegisterUsernameMissingOrInvalid = 'register_username_missing_or_invalid',
  RegisterHorseColorsMissingOrInvalid = 'register_horse_colors_missing_or_invalid',
  RegisterCountryMissingOrInvalid = 'register_country_missing_or_invalid',
  RegisterEmailMissingOrInvalid = 'register_email_missing_or_invalid',
  RegisterUsernameAlreadyExists = 'register_username_already_exists',
  RegisterFirebaseUidAlreadyExists = 'register_firebase_uid_already_exists',
  RegisterEmailAlreadyExists = 'register_email_already_exists',
  RegisterUserCheckFailed = 'register_user_check_failed',
  RegisterUserCreationFailed = 'register_user_creation_failed',
  RegisterUserNotFound = 'register_user_not_found',

  RefreshTokenMissing = 'refresh_token_missing',
  RefreshTokenInvalidOrExpired = 'refresh_token_invalid_or_expired',
  RefreshUserNotFound = 'refresh_user_not_found',

  PasswordResetEmailMissingOrInvalid = 'password_reset_email_missing_or_invalid',
  PasswordResetUserNotFound = 'password_reset_user_not_found',
  PasswordResetInvalidEmail = 'password_reset_invalid_email',
  PasswordResetTooManyRequests = 'password_reset_too_many_requests',
  PasswordResetFailed = 'password_reset_failed',

  FirebaseUidNotFound = 'firebase_uid_not_found',

  RelinkEmailMissingOrInvalid = 'relink_email_missing_or_invalid',
  RelinkEmailNotVerified = 'relink_email_not_verified',
  RelinkCandidateNotFound = 'relink_candidate_not_found',
  RelinkConflict = 'relink_conflict',
  RelinkFailed = 'relink_failed',

  TurnstileRequired = 'turnstile_required',
  TurnstileVerificationFailed = 'turnstile_verification_failed',
  TurnstileVerificationInternalError = 'turnstile_verification_internal_error',
}
